// Horizontally centred, wrapping row for action buttons at the bottom of a phase card.
import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";

const ActionButtonRow = ({ children }) => (
  <Box sx={{ display: "flex", justifyContent: "center", gap: 1.5, flexWrap: "wrap", mt: 0.5 }}>
    {children}
  </Box>
);

ActionButtonRow.propTypes = { children: PropTypes.node };

export default ActionButtonRow;
